import { styled } from '@mui/material';
import WorkspacesOutlinedIcon from '@mui/icons-material/WorkspacesOutlined';

const ProjectIcon = styled(WorkspacesOutlinedIcon)``;

export default ProjectIcon;
